import React, { Component } from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import { injectIntl, FormattedMessage } from "react-intl";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { fetchTranslations } from "./locales/config";

import { SolutionTube } from "@learningblocks/storybook-components/lib/ProtocolComponents/SolutionTube";

import { setModal } from "../ModalHandler/store/actions";
import { MODAL_TYPES } from "./modals";

import {
  addSolutionToAssayPrediction,
  removeSolutionFromAssayPrediction,
  setPredictionValidation,
  setAssayPrediction,
  submitAnswer,
} from "./store/actions";

import warning from "./img/note-icon.svg";
import poster from "./img/poster.svg";
import labTable from "./img/Table.svg";
import solutionStand from "./img/tube-stand-8.svg";
import dragDropInstruction from "./img/drag-n-drop-instruction.svg";
import dnacleavagetube from "./img/dna-cleavage-assay-tube.svg";

import "./style.scss";

const images = {
  warning: warning,
};
export const scale = 1;
export let objCurrent = null;
export let objPrevious = null;
export const arTargets = [];

export const calculatePosition = (objElement) => {
  const objPos = objElement.getBoundingClientRect();
  return objPos;
};

export const getTransform = (elem) => {
  const matrix = getComputedStyle(elem, null).transform;

  const regex = /-?\d*\.{0,1}\d+/g;
  const values = matrix.match(regex);

  let translateX = "";
  let translateY = "";

  if (values !== null) {
    translateX = values[4];
    translateY = values[5];
  }

  return {
    translateX: translateX,
    translateY: translateY,
  };
};

export const unscaledStart = (objEvent, target) => {
  objCurrent = target;

  objCurrent.lastX = objEvent.clientX;
  objCurrent.lastY = objEvent.clientY;
  objCurrent.lastRotation = 0;
  objCurrent.isAnimated = false;
  objCurrent.style.zIndex = "99";
  objCurrent.setAttribute("aria-grabbed", "true");

  return false;
};

export const end = () => {
  if (objCurrent !== null) {
    objCurrent.style.zIndex = "2";
    objCurrent.setAttribute("aria-grabbed", "false");
    if (objPrevious !== null && objPrevious !== objCurrent) {
      objPrevious.style.zIndex = "";
    }
    objPrevious = objCurrent;
  }
  objCurrent = null;

  return false;
};

export const unscaledDrag = (objEvent) => {
  if (objCurrent !== null) {
    // Calculate new position
    const iCurrentY = objEvent.clientY;
    const iCurrentX = objEvent.clientX;

    const transform = getTransform(objCurrent);

    const iYPos = parseFloat(transform.translateY);
    const iXPos = parseFloat(transform.translateX);

    const iNewX = iXPos + iCurrentX - objCurrent.lastX;
    const iNewY = iYPos + iCurrentY - objCurrent.lastY;

    const rotation = 0;
    const rotate = 0;

    objCurrent.style.transform =
      "translate3d(" +
      iNewX +
      "px, " +
      iNewY +
      "px, 0px) rotateZ(" +
      rotate +
      "deg) ";

    objCurrent.lastX = iCurrentX;
    objCurrent.lastY = iCurrentY;
    objCurrent.lastRotation = rotation;
    objCurrent.isAnimated = false;
  }
  return false;
};

export const getUnscaledTarget = (current, targetList) => {
  if (current !== null) {
    let offset = calculatePosition(current);

    const iCurrentXCenter = offset.left + current.offsetWidth / 2;
    const iCurrentYCenter = offset.top + current.offsetHeight / 2;

    let iLeft, iRight, iTop, iBottom, iCounter;

    for (iCounter = 0; iCounter < targetList.length; iCounter++) {
      if (current.id !== targetList[iCounter].id) {
        offset = calculatePosition(targetList[iCounter]);

        iLeft = offset.left;
        iRight = iLeft + targetList[iCounter].offsetWidth;
        iTop = offset.top;
        iBottom = iTop + targetList[iCounter].offsetHeight;

        if (
          iCurrentXCenter > iLeft &&
          iCurrentXCenter < iRight &&
          iCurrentYCenter > iTop &&
          iCurrentYCenter < iBottom
        ) {
          return targetList[iCounter];
        }
      }
    }
  }

  return "";
};

class Predictions33 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragdropStyle: {},
      targetList: [],
      validated: this.props.validated,
      correct: this.props.correct,
      warningMessage: this.props.intl.formatMessage({
        id: "That is incorrect.",
        defaultMessage: "That is incorrect.",
        description: "",
      }),
    };
    this.solutions = [
      {
        type: "CCR5 DNA",
        fullName: this.props.intl.formatMessage({
          id: "CCR5 DNA Solution",
          defaultMessage: "CCR5 DNA Solution",
          description: "",
        }),
        volume: 1,
        description: this.props.intl.formatMessage({
          id: "The PCR-amplified (linearized) CCR5 gene, with blue label.",
          defaultMessage:
            "The PCR-amplified (linearized) CCR5 gene, with blue label.",
          description: "",
        }),
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#2353A4",
          circleOutline: "#2353A4",
        },
      },
      {
        type: "CAS9 Protein",
        fullName: this.props.intl.formatMessage({
          id: "Cas9 Protein Solution",
          defaultMessage: "Cas9 Protein Solution",
          description: "",
        }),
        volume: 1,
        description: this.props.intl.formatMessage({
          id: "Purified, functional Cas9 protein, with red label.",
          defaultMessage: "Purified, functional Cas9 protein, with red label.",
          description: "",
        }),
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#C87176",
          circleOutline: "#C87176",
        },
      },
      {
        type: "DNA Ladder",
        fullName: this.props.intl.formatMessage({
          id: "DNA Ladder Solution",
          defaultMessage: "DNA Ladder Solution",
          description: "",
        }),
        volume: 10,
        description: this.props.intl.formatMessage({
          id: "Molecular weight marker that serves to compare the molecular sizes of DNA in a gel, with a black label.",
          defaultMessage:
            "Molecular weight marker that serves to compare the molecular sizes of DNA in a gel, with a black label.",
          description: "",
        }),
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#70615F",
          circleOutline: "#70615F",
        },
      },
      {
        type: "10x DNA Cleavage Buffer",
        fullName: this.props.intl.formatMessage({
          id: "10x DNA Cleavage Buffer Solution",
          defaultMessage: "10x DNA Cleavage Buffer Solution",
          description: "",
        }),
        volume: 1,
        description: this.props.intl.formatMessage({
          id: "DNA cleavage buffer that is 10 times more concentrated than the buffer in the DNA cleavage reaction. Labeled green. Buffers ensure a stable pH and osmolarity for enzymes to work effectively.",
          defaultMessage:
            "DNA cleavage buffer that is 10 times more concentrated than the buffer in the DNA cleavage reaction. Labeled green. Buffers ensure a stable pH and osmolarity for enzymes to work effectively.",
          description: "",
        }),
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#78C871",
          circleOutline: "#78C871",
        },
      },
      {
        type: "CCR5 mRNA",
        fullName: this.props.intl.formatMessage({
          id: "CCR5 mRNA Solution",
          defaultMessage: "CCR5 mRNA Solution",
          description: "",
        }),
        volume: 1,
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#70615F",
          circleOutline: "#70615F",
        },
      },
      {
        type: "CAS9 DNA",
        fullName: this.props.intl.formatMessage({
          id: "Cas9 DNA",
          defaultMessage: "Cas9 DNA",
          description: "",
        }),
        volume: 1,
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#70615F",
          circleOutline: "#70615F",
        },
      },
      {
        type: "gRNA against CCR5",
        fullName: this.props.intl.formatMessage({
          id: "gRNA against CCR5",
          defaultMessage: "gRNA against CCR5",
          description: "",
        }),
        volume: 1,
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#70615F",
          circleOutline: "#70615F",
        },
      },
      {
        type: "gRNA against CAS9",
        fullName: this.props.intl.formatMessage({
          id: "gRNA against Cas9",
          defaultMessage: "gRNA against Cas9",
          description: "",
        }),
        volume: 1,
        solutionTube: {
          solutionColor: "#00AEEF",
          circleColor: "#70615F",
          circleOutline: "#70615F",
        },
      },
    ];
  }

  addAssaySolution = (solution) => {
    this.props.addSolutionToAssayPrediction({
      solution: solution,
    });
  };

  removeAssaySolution = (solution) => {
    this.props.removeSolutionFromAssayPrediction({
      solution: solution,
    });
  };

  showPoster = () => {
    this.props.setModal({
      display: true,
      type: MODAL_TYPES.PredictionsPoster,
      size: "lg",
      connect: -1,
    });
  };

  getContentItemColorStyle = (solution) => {
    const colors = {
      "gRNA-a": "#e0dcdc",
      "gRNA-b": "#e0dcdc",
      "gRNA-c": "#e0dcdc",
      "CCR5 DNA": "#003e6b",
      "CAS9 Protein": "#d67774",
      "DNA Ladder": "#70615f",
      "Control gRNA": "#ef2d96",
      "10x DNA Cleavage Buffer": "#4cb862",
      Water: "#d0e0ff",
      "CCR5 mRNA": "#70615f",
      "CAS9 DNA": "#70615f",
      "gRNA against CCR5": "#70615f",
      "gRNA against CAS9": "#70615f",
    };
    return colors[solution];
  };

  renderAssayContents = () => {
    const contents = this.props.assayPrediction;
    const outArr = [];

    for (const solution in contents) {
      const colorStyle = this.getContentItemColorStyle(solution);
      if (Object.hasOwn(contents, solution)) {
        outArr.push(
          <div
            key={solution}
            className="assay-solution-card"
            aria-label={
              solution === "CAS9 Protein" ? "Cas9 Protein." : solution + "."
            }
          >
            <div className="card-flex">
              <div
                className="assay-solution-card__color"
                style={{ backgroundColor: colorStyle }}
              ></div>
              <div className="assay-solution-card__label">
                {solution === "CAS9 Protein" ? "Cas9 Protein" : solution}
              </div>
            </div>

            <div
              className="assay-solution-card__remove-btn"
              role="button"
              tabIndex={0}
              onClick={() => this.removeAssaySolution(solution)}
              aria-label={this.props.intl.formatMessage(
                {
                  id: "Select to remove {solution} from DNA cleavage assay tube.",
                  defaultMessage:
                    "Select to remove {solution} from DNA cleavage assay tube.",
                  description: "",
                },
                {
                  solution: solution,
                }
              )}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  this.removeAssaySolution(solution);
                }
              }}
            >
              x
            </div>
          </div>
        );
      }
    }

    return outArr;
  };

  renderSolutionTubes = () => {
    const solutionArr = [];

    for (let i = 0; i < this.solutions.length; i++) {
      const solution = this.solutions[i];

      if (
        this.props.attemptsLeft <= 2 &&
        (solution.type === "CAS9 DNA" || solution.type === "CCR5 mRNA")
      ) {
        continue;
      }

      solutionArr.push(
        <div
          key={i}
          className="solutions__drag"
          id={"solution-dragger_" + solution.type + "_" + i}
          draggable
          role="button"
          tabIndex={0}
          onClick={() => this.addAssaySolution(solution.type)}
          aria-label={this.props.intl.formatMessage({
            id: "Select to add to the DNA clevage assay tube.",
            defaultMessage: "Select to add to the DNA clevage assay tube.",
            description: "",
          })}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              this.addAssaySolution(solution.type);
            }
          }}
        >
          <div style={{ pointerEvents: "none" }}>
            <p className="solutions__drag--label" aria-hidden="true">
              {solution.type}
            </p>
            <SolutionTube
              title={solution.label}
              isOpen={true}
              id={i}
              size={solution.solutionTube.size}
              type={solution.solutionTube.type}
              solution={{
                solutionColor: solution.solutionTube.solutionColor,
                circleColor: solution.solutionTube.circleColor,
                circleOutline: solution.solutionTube.circleOutline,
                isOpen: false,
                label: solution.solutionTube.label,
              }}
            />
            {/* <Solution id={solution.id} /> */}
          </div>
        </div>
      );
    }

    return solutionArr;
  };

  //DRAG STUFF START

  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    unscaledStart(e, e.target);
  };

  onDragOver = (e) => {
    e.preventDefault();
    unscaledDrag(e);
  };

  onDrop = (e) => {
    e.preventDefault();

    const target = getUnscaledTarget(e.target, this.state.targetList);

    if (target !== "") {
      if (target.id.includes("cleavage-drop-area")) {
        this.addAssaySolution(e.target.id.split("_")[1]);
      }
    }

    //Always reset position after drop
    e.target.style.transform = "translate3d(0px, 0px, 0px) rotateZ(0deg)";

    end(e);
  };

  componentDidMount() {
    this.setState({
      targetList: [document.getElementById("cleavage-drop-area")],
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.attemptsLeft !== this.props.attemptsLeft ||
      prevProps.modalDisplay !== this.props.modalDisplay
    ) {
      this.warningMessage.focus();
    }
  }
  // DRAG STUFF END

  submitAnswer = () => {
    if (
      isEqual(
        Object.keys(this.props.assayPrediction).sort(),
        [
          "10x DNA Cleavage Buffer",
          "CAS9 Protein",
          "CCR5 DNA",
          "gRNA against CCR5",
        ].sort()
      )
    ) {
      this.setState({
        correct: true,
      });

      this.props.setModal({
        display: true,
        type: MODAL_TYPES.PredictionImageCorrect,
        size: "lg",
        connect: -1,
        data: this.props.modal,
      });
    } else {
      this.setState(
        {
          false: true,
        },
        () => {
          if (this.props.attemptsLeft === 4) {
            // this.setState({
            //   warningMessage: "4"
            // })
            this.props.setModal({
              display: true,
              type: MODAL_TYPES.PredictionImage,
              size: "lg",
              connect: -1,
              data: this.props.modal,
            });
          } else if (this.props.attemptsLeft === 3) {
            this.setState({
              warningMessage: this.props.intl.formatMessage({
                id: "Incorrect. You only need four reagents to create this DNA cleavage assay.",
                defaultMessage:
                  "Incorrect. You only need four reagents to create this DNA cleavage assay.",
                description: "",
              }),
            });
          } else if (this.props.attemptsLeft === 2) {
            this.setState({
              warningMessage: this.props.intl.formatMessage({
                id: "Incorrect. Two reagent options have been removed to help you design your assay.",
                defaultMessage:
                  "Incorrect. Two reagent options have been removed to help you design your assay.",
                description: "",
              }),
            });

            const solution = this.props.assayPrediction;

            delete solution["CCR5 mRNA"];
            delete solution["CAS9 DNA"];

            this.props.removeSolutionFromAssayPrediction({
              solution: solution,
            });
          } else if (this.props.attemptsLeft === 1) {
            this.setState({
              warningMessage: this.props.intl.formatMessage({
                id: "That is incorrect.",
                defaultMessage: "That is incorrect.",
                description: "",
              }),
            });
          } else if (this.props.attemptsLeft === 0) {
            this.setState({
              warningMessage: this.props.intl.formatMessage({
                id: "Incorrect. Your lab supervisor saw that you needed some help and has provided the DNA cleavage assay.",
                defaultMessage:
                  "Incorrect. Your lab supervisor saw that you needed some help and has provided the DNA cleavage assay.",
                description: "",
              }),
            });

            this.props.setAssayPrediction({
              solution: {
                "10x DNA Cleavage Buffer": 1,
                "CAS9 Protein": 1,
                "CCR5 DNA": 1,
                "gRNA against CCR5": 1,
              },
            });

            this.props.setPredictionValidation({
              validated: true,
              correct: true,
            });
          }
        }
      );
    }

    this.setState({
      validated: true,
    });

    this.props.setPredictionValidation({
      validated: true,
      correct: this.state.correct,
    });
    this.props.submitAnswer();
  };

  getWarningMessage = () => {
    if (this.props.attemptsLeft === 5) {
      return "";
    } else if (this.props.attemptsLeft === 4) {
      return this.props.intl.formatMessage({
        id: "That is incorrect.",
        defaultMessage: "That is incorrect.",
        description: "",
      });
    } else if (this.props.attemptsLeft === 3) {
      return this.props.intl.formatMessage({
        id: "Incorrect. You only need four reagents to create this DNA cleavage assay.",
        defaultMessage:
          "Incorrect. You only need four reagents to create this DNA cleavage assay.",
        description: "",
      });
    } else if (this.props.attemptsLeft === 2) {
      return this.props.intl.formatMessage({
        id: "Incorrect. Two reagent options have been removed to help you design your assay.",
        defaultMessage:
          "Incorrect. Two reagent options have been removed to help you design your assay.",
        description: "",
      });
    } else if (this.props.attemptsLeft === 1) {
      return this.props.intl.formatMessage({
        id: "That is incorrect.",
        defaultMessage: "That is incorrect.",
        description: "",
      });
    } else if (this.props.attemptsLeft === 0) {
      return this.props.intl.formatMessage({
        id: "Incorrect. Your lab supervisor saw that you needed some help and has provided the DNA cleavage assay.",
        defaultMessage:
          "Incorrect. Your lab supervisor saw that you needed some help and has provided the DNA cleavage assay.",
        description: "",
      });
    }
  };

  render() {
    return (
      <div className="Predictions">
        <div className="assay-prediction-container">
          <div className="assay-prediction-container__primary-prediction">
            <div className="assay-prediction-header">
              <h4 className="assay-prediction-header__title">
                <FormattedMessage
                  id="Drag and drop"
                  defaultMessage="Drag and drop"
                  description=""
                />
              </h4>

              <p className="assay-prediction-header__text">
                <FormattedMessage
                  id="Drag the required reagents into the DNA cleavage assay test tube. View the poster on the wall, which illustrates a restriction digest, if you require any help."
                  defaultMessage="Drag the required reagents into the DNA cleavage assay test tube. View the poster on the wall, which illustrates a restriction digest, if you require any help."
                  description=""
                />
              </p>
            </div>

            <div
              className="mini-scene-container"
              onDragStart={this.onDragStart}
              onDragOver={this.onDragOver}
              onDrop={this.onDrop}
            >
              <div
                className="mini-scene-container__poster"
                tabIndex={0}
                onClick={this.showPoster}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.showPoster();
                  }
                }}
                role="button"
                aria-label="Click to enlarge poster"
              >
                <img
                  src={poster}
                  alt={this.props.intl.formatMessage({
                    id: "Poster, click to enlarge.",
                    defaultMessage: "Poster, click to enlarge.",
                    description: "",
                  })}
                />
              </div>

              <div className="mini-scene-container__drag-n-drop-instruction">
                <img
                  src={dragDropInstruction}
                  alt={this.props.intl.formatMessage({
                    id: "Drag reagents into the DNA cleavage assay test tube. You can also press enter while focusing on a solution to move it.",
                    defaultMessage:
                      "Drag reagents into the DNA cleavage assay test tube. You can also press enter while focusing on a solution to move it.",
                    description: "",
                  })}
                />
              </div>

              <div
                className="mini-scene-container__cleavage-drop-area dropTarget drop-area"
                id="cleavage-drop-area"
              >
                <div className="mini-scene-container__cleavage-drop-area--drop-area-instructions">
                  <FormattedMessage
                    id="Drag and drop here"
                    defaultMessage="Drag and drop here"
                    description=""
                  />
                </div>

                <img
                  src={dnacleavagetube}
                  alt={this.props.intl.formatMessage({
                    id: "DNA cleavage assay test tube.",
                    defaultMessage: "DNA cleavage assay test tube.",
                    description: "",
                  })}
                />

                <div className="drag-drop-tooltip">
                  <div className="drag-drop-tooltip__tip"></div>
                  <span>
                    <FormattedMessage
                      id="DNA cleavage assay test tube"
                      defaultMessage="DNA cleavage assay test tube"
                      description=""
                    />
                  </span>
                </div>
              </div>

              <div className="solutions">{this.renderSolutionTubes()}</div>

              <div
                className="mini-scene-container__solution-stand"
                style={{ pointerEvents: "none" }}
              >
                <img
                  src={solutionStand}
                  alt="Solution rack."
                  draggable="false"
                  style={{ pointerEvents: "none" }}
                />
              </div>

              <div className="mini-scene-container__table">
                <img
                  src={labTable}
                  alt={this.props.intl.formatMessage({
                    id: "Scene table.",
                    defaultMessage: "Scene table.",
                    description: "",
                  })}
                  draggable="false"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            </div>
          </div>
          <div className="assay-contents-container">
            <div className="assay-contents-left">
              <h5 style={{ marginTop: "15px", marginBottom: "0px" }}>
                <FormattedMessage
                  id="DNA cleavage assay tube contents"
                  defaultMessage="DNA cleavage assay tube contents"
                  description=""
                />
              </h5>
            </div>
            <div className="assay-contents-right">
              {this.renderAssayContents()}
            </div>
          </div>

          <div
            className={
              "warning-display-container " +
              (this.state.correct ? "correct" : "incorrect")
            }
            style={{
              display:
                this.state.validated && !this.state.correct ? null : "none",
            }}
            ref={(warningMessage) => {
              this.warningMessage = warningMessage;
            }}
          >
            <div className="warning-display-container__image">
              <div>
                <img
                  src={images.warning}
                  alt={this.props.intl.formatMessage({
                    id: "Warning icon.",
                    defaultMessage: "Warning icon.",
                    description: "",
                  })}
                />
              </div>

              <div className="warning-display-container__image--label">
                <FormattedMessage
                  id="NOTE"
                  defaultMessage="NOTE"
                  description=""
                />
              </div>
            </div>
            <div className="warning-display-container__message">
              {this.getWarningMessage()}
            </div>
          </div>

          <div className="panel-footer">
            <div className="panel-footer__attempts">
              {this.props.intl.formatMessage(
                {
                  id: "Attempts left: {attempts}",
                  defaultMessage: "Attempts left: {attempts}",
                  description: "",
                },
                {
                  attempts: this.props.correct ? "-" : this.props.attemptsLeft,
                }
              )}
            </div>
            <button
              className="panel-footer__submit-btn"
              onClick={this.submitAnswer}
            >
              {this.props.correct || this.props.attemptsLeft === 0
                ? this.props.intl.formatMessage({
                    id: "View Poster",
                    defaultMessage: "View Poster",
                    description: "",
                  })
                : this.props.intl.formatMessage({
                    id: "Submit Answer",
                    defaultMessage: "Submit Answer",
                    description: "",
                  })}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assayPrediction: state.predictions.predictions,
    attemptsLeft: state.predictions.attemptsLeft,
    correct: state.predictions.correct,
    validated: state.predictions.attemptsLeft == 5 ? false : true,
  };
};

const Predictions33WithIntl = injectIntl(Predictions33);

export const AssayPredictions = connect(mapStateToProps, {
  addSolutionToAssayPrediction,
  removeSolutionFromAssayPrediction,
  setModal,
  setPredictionValidation,
  setAssayPrediction,
  submitAnswer,
})((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <Predictions33WithIntl {...props} />
  </TranslationsProvider>
));
